




























































import Vue from 'vue';
// @ts-ignore
import bwipjs from 'bwip-js';
// @ts-ignore
import barcode from 'jsbarcode';

export default Vue.extend({
    data() {
        return {
            barcodes: '',
            qrcodes: '',
            qrFilename: ''
        }
    },
    mounted() {
    },
    methods: {
        downloadQrCode() {
            if (this.qrFilename === '') {
                this.qrFilename = 'qrcode'
            }

            const canvas = document.getElementById('qrcode-canvas') as HTMLCanvasElement;
            const dataURL = canvas.toDataURL('image/png');
            const link = document.createElement('a');
            link.href = dataURL;
            link.download = this.qrFilename + '.png';

            // download the image
            link.click();
        },
        generateQr() {
            bwipjs('qrcode-canvas', {
                bcid:        'qrcode',       // Barcode type
                text:        this.qrcodes,    // Text to encode
                data:        this.qrcodes,    // Text to encode
                scale:       1,               // 3x scaling factor
                height:      4096,              // Bar height, in millimeters
                width:      4096,              // Bar height, in millimeters
                includetext: true,            // Show human-readable text
                includecheck: true,
                textxalign:  'center',        // Always good to set this
                // monochrome: true,
                textcolor: '000000',
                showborder: true,
                // barcolor: 'AA000000',
                // backgroundcolor: 'FFFF60'
            }, function (err: any, cvs: any) {
                if (err) {
                    // Decide how to handle the error
                    // `err` may be a string or Error object
                } else {
                    // Nothing else to do in this example...
                }
            });
        }
    },
    watch: {
        barcodes() {
            barcode(
                this.$refs.barcodeCanvas,
                this.barcodes,
                {
                    format: 'CODE39',
                    width: 1
                }
            );
            
            bwipjs('barcode-canvas', {
                bcid:        'code128',       // Barcode type
                text:        this.barcodes,    // Text to encode
                data:        this.barcodes,    // Text to encode
                scale:       3,               // 3x scaling factor
                height:      10,              // Bar height, in millimeters
                includetext: true,            // Show human-readable text
                includecheck: true,
                textxalign:  'center',        // Always good to set this
                // monochrome: true,
                textcolor: '000000',
                showborder: true,
                // barcolor: 'AA000000',
                // backgroundcolor: 'FFFF60'
            }, function (err: any, cvs: any) {
                if (err) {
                    // Decide how to handle the error
                    // `err` may be a string or Error object
                } else {
                    // Nothing else to do in this example...
                }
            });
        }
    },
    computed: {
        results(): string[] {
            return this.barcodes.split("\n")
        }
    }
})
